module.exports = __webpack_public_path__ + "img/IMG_9378-44.a9850683.jpg";